// removed by extract-text-webpack-plugin
module.exports = {"Navigation":"Navigation__5qDAD","Container":"Container__36Jcp","CenterVertical":"CenterVertical__yj0c_","Links":"Links__t3N5G","CenterXY":"CenterXY__2k4Dx","OpenNavButton":"OpenNavButton__1Mck6","Brand":"Brand__13TA-","Logo":"Logo__3lx4X","NavOpen":"NavOpen__3TBrt"};


//////////////////
// WEBPACK FOOTER
// ./components/Navigation/Navigation.scss
// module id = nPG2
// module chunks = 0